exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trip-convoy-cell[data-v-a3d9f79c]{min-height:1.5rem;display:inline-flex;align-items:center;justify-content:center}.trip-convoy-cell__button[data-v-a3d9f79c]{color:var(--brand-color,#ff7a18)!important}.trip-convoy-cell__placeholder[data-v-a3d9f79c]{color:#8a94a6;letter-spacing:.08em;font-weight:600}", ""]);

// exports
